// Auto generated file, do not manually modify!
// com.hotpads.yourrentalapi.enums.TagAppearance

export enum TagAppearance {
  CRITICAL = 'CRITICAL',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
}

export const TagAppearance_values = [
  TagAppearance.CRITICAL,
  TagAppearance.INFO,
  TagAppearance.SUCCESS,
  TagAppearance.WARNING,
] as const;
